import { Box, Typography } from "@mui/material";
import { RiskFactorStats } from "~/operations";
import { getRiskFactorIcon } from "~/pages/space/security/components/RiskFactors/utils";

type CompactRiskFactorsIconsProps = {
  riskFactors: Array<RiskFactorStats | null>;
};

export function CompactRiskFactorsIcons({
  riskFactors,
}: CompactRiskFactorsIconsProps) {
  const activeRiskFactors = riskFactors.filter(
    (rf): rf is RiskFactorStats => rf !== null && rf.affected > 0,
  );

  if (activeRiskFactors.length === 0) {
    return null;
  }

  const first = activeRiskFactors[0];
  const remaining = activeRiskFactors.length - 1;

  const icon = getRiskFactorIcon({
    indicator: first.indicator,
    sx: { fontSize: 16 },
  });

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {icon}
      {remaining > 0 && (
        <Typography variant="caption" color="text.secondary">
          +{remaining}
        </Typography>
      )}
    </Box>
  );
}
